import React from 'react'
import { useTranslation } from 'react-i18next'

import ModalContextProvider from './ModalContext'
import ModalContextButton from './ModalContextButton'

import '../../css/common/KeyList.css'

type GenericModalProps = {
  children: JSX.Element
  disableModal: boolean
  disableOkButton?: boolean
  title: string
  preOk?: () => boolean
  onOk: () => void
  onClose?: () => void
  modalBody: JSX.Element
  buttonOkText: string
}
const GenericModal = ({
  children,
  disableModal,
  disableOkButton,
  title,
  preOk,
  onOk,
  onClose,
  modalBody,
  buttonOkText,
}: GenericModalProps) => {
  const { t } = useTranslation()
  return (
    <ModalContextProvider
      title={title}
      body={modalBody}
      buttonOk={buttonOkText}
      buttonCancel={t('close')}
      buttonOkWarn={false}
      buttonOkDisabled={disableOkButton}
      buttonOkValidation={preOk}
    >
      <ModalContextButton
        onOk={onOk}
        onCancel={onClose}
        disabled={disableModal}
      >
        {children}
      </ModalContextButton>
    </ModalContextProvider>
  )
}

export default GenericModal
